export type TMaskType = 'none' | 'credit-card' | 'card-expiry' | 'zip' | 'phone'

export function onlyDigits(value: string): string {
  return value.replace(/\D+/g, '')
}

export function formatCreditCard(digits: string): {
  display: string
  raw: string
} {
  const raw = digits.slice(0, 19)
  const parts: string[] = []
  for (let i = 0; i < raw.length; i += 4) parts.push(raw.slice(i, i + 4))
  return { display: parts.join(' ').trim(), raw }
}

export function formatExpiry(digits: string): { display: string; raw: string } {
  const raw = digits.slice(0, 4)
  const month = raw.slice(0, 2)
  const year = raw.slice(2, 4)
  const display = year ? `${month}/${year}` : month
  return { display, raw }
}

export function formatZip(digits: string): { display: string; raw: string } {
  // support US ZIP 5 or ZIP+4 displayed as 12345-6789
  const raw = digits.slice(0, 9)
  if (raw.length <= 5) return { display: raw, raw }
  return { display: `${raw.slice(0, 5)}-${raw.slice(5)}`, raw }
}

export function formatPhone(digits: string): { display: string; raw: string } {
  // Basic NANP formatting: (123) 456-7890
  const raw = digits.slice(0, 11)
  const len = raw.length
  if (len <= 3) return { display: raw, raw }
  if (len <= 6) return { display: `(${raw.slice(0, 3)}) ${raw.slice(3)}`, raw }
  return {
    display: `(${raw.slice(0, 3)}) ${raw.slice(3, 6)}-${raw.slice(6)}`,
    raw
  }
}

export function applyMask(
  mask: TMaskType,
  value: string
): { display: string; raw: string } {
  switch (mask) {
    case 'credit-card':
      return formatCreditCard(onlyDigits(value))
    case 'card-expiry':
      return formatExpiry(onlyDigits(value))
    case 'zip':
      return formatZip(onlyDigits(value))
    case 'phone':
      return formatPhone(onlyDigits(value))
    case 'none':
    default:
      return { display: value, raw: value }
  }
}
